import React, { useEffect } from 'react'
import hawaiiImage from '../../assets/images/hawaii.jpg'
import about2Image from '../../assets/images/care_hawaii1.jpg'
import about3Image from '../../assets/images/care_hawaii_group_photo.jpg'
import about4Image from '../../assets/images/care_hawaii6.jpg'


import { Jumbotron, Container, Row, Col, Image, Card } from 'react-bootstrap'
import '../../assets/scss/index.scss'
import {FadeOnUp, FadeOn} from 'nehoa'

import '../../pages/Main/index.css'
import EventsPage from '../../components/EventsCalendar'


//unused

// import eventImage from '../../assets/images/events.jpg'
// import API from '../../utils/API'
// import parse from 'html-react-parser';
// import { Link } from 'react-router-dom';
// import FullCalendar from '@fullcalendar/react'
// import dayGridPlugin from '@fullcalendar/daygrid'
// import interactionPlugin from "@fullcalendar/interaction"; 
// import timeGridPlugin from '@fullcalendar/timegrid'

export default function Main() {
    // var reser = []
    // const [newsInfo, setNewsInfo] = useState([]);
    async function getNewsInfo() {
        try {
            
                // API.getTopNews().then(
                //     function (response) {
                //         response.data.slice(2)
                //         setNewsInfo(response.data)
                //     })
        }
        catch (error) {
            throw error
        }

    }
    useEffect(() => {
        getNewsInfo()
    }, []);

    return (
        <>
        {/* <Jumbotron style={{ margin: '0', textAlign: 'center', padding: '0'}}>
            <p className='mainFont' style={{fontSize: '0.80em', padding: '10px', color: '#777777', margin: '0'}}>We will be closed 8/08/2020 before 4:00PM</p>
        </Jumbotron> */}
        <Jumbotron style={{paddingTop: '0', backgroundColor: '#999999', backgroundImage: `url(${hawaiiImage})`, backgroundPosition: 'center center', backgroundRepeat: 'no-repeat', backgroundSize: 'cover', height: '75vh'}} fluid>
        <div className='bannerTitleDiv'>
        <FadeOn duration='2s' className='mainTitleFont'>CARE Hawaii</FadeOn>
        <br />
        <FadeOnUp duration='2s' className='subTitleFont'>We are here for you</FadeOnUp>
        </div>
      
        </Jumbotron >
        <Container style={{marginTop: '25px'}} fluid>
        <p className='mainFont' style={{fontSize: '2em'}}>CARE Hawaii</p><hr/>
        <Row>
            <Col lg='5' >
        <Image style ={{width: '100%'}}src={about2Image} fluid/>
        <br />
        <br />
        <Image style ={{width: '100%'}}src={about3Image} fluid/>
            </Col>
          
            <Col lg='7'>
            <br />
            
            <p className="mainFont">
            CARE Hawaii, Inc. was founded in 1999 to provide outpatient mental health services to Hawaii's children, adolescents and adults through a network of mental health professionals committed to best practices in service delivery. CARE Hawaii, Inc. services individuals with serious mental illness, developmental delays, and substance related issues. With available services throughout the State of Hawaii, CARE Hawaii Inc.'s mission is to provide a comprehensive array of behavioral health services to promote the physical, emotional, social, spiritual, recreational, and educational development of all identified consumers and their families/significant others.
            </p>
            <p className='mainFont' style={{ color: "#222222", fontSize: '1.25em', margin: '0' }}>Our Vision</p><br />
                        <p className='mainFont' style={{ color: "#222222", fontSize: '1em', margin: '0', paddingLeft: '20px' }}>
                            CARE Hawaii’s vision is that every child, adolescent, adult, and their family/significant other
                            in Hawaii will have maximum opportunity to reach their potential in all spheres of their
                            lives.
                        </p>
                        <br />
                        <p className='mainFont' style={{ color: "#222222", fontSize: '1.25em', margin: '0' }}>Our Mission</p><br />
                        <p className='mainFont' style={{ color: "#222222", fontSize: '1em', margin: '0', paddingLeft: '20px'  }}>
                        CARE Hawaii’s mission is to provide a comprehensive array of mental health and addiction
                        services to promote the physical, emotional, spiritual, and educational development of all
                        identified clients and their families/significant others.
                        </p>
                        <br />
                        <p className='mainFont' style={{ color: "#222222", fontSize: '1.25em', margin: '0' }}>Our Philosophy</p><br />
                        <p className='mainFont' style={{ color: "#222222", fontSize: '1em', margin: '0', paddingLeft: '20px'  }}>
                        The philosophy of treatment and services embraced by CARE Hawaii is that of empowering
                        all clients and their families/ significant others with skills to successfully meet the challenges
                        of growth and development.
                        </p><br />
            
          
            </Col>
            {/* <Col lg='3' style={{borderLeft: '1px solid black'}}>
            <p className='mainFont' style={{fontSize: '1.25em', marginTop: '20px'}}>
                News
            </p>
            <hr/>
            {newsInfo.map(item => (      
            <div>                   
            <Link style={{ color: '#000000' }} to={"/NewsDetails/" + item._id}>{item.title}</Link>
            <p className='mainFont' style={{ fontSize: '0.6em' }}>posted: {item.date}</p>
            <p className='mainFont' style={{ fontSize: '0.6em' }}>{parse(item.newsText)}</p>
            </div>
            ))}
            </Col> */}
        </Row>
        <br /><br />
        <p className='mainFont' style={{fontSize: '1.5em'}}>Contact Information</p><hr/>
        <Row>
            <Col lg={6} sm={12}>
            <Card>
            <Card.Body>
           
                <Card.Text style={{textAlign: 'center'}}>
                <a className='mainFont' style={{color: '#000000', fontSize: '1em', textDecoration: 'none', align: 'center'}} href='tel:808-533-3936'>Phone: (808) 533-3936</a><br /><br />
                <a className='mainFont' style={{color: '#000000', fontSize: '1em', textDecoration: 'none'}} href='mailto:info@carehawaii.info'>Email: info@carehawaii.com</a><br /><br />
                <span className='mainFont' style={{color: '#000000',  marginBottom: '0', fontSize: '1em'}}>Hours: Monday-Friday 8:00am-5:00pm</span><br /><br />
                <a className='mainFont' target='_blank' rel="noopener noreferrer" href='https://goo.gl/maps/A4KP8xWNDXXPZp3j9' style={{color: '#000000', fontSize: '1em', textDecoration: 'none'}}>Address: 875 Waimanu St. Honolulu, HI 96813</a><br />
                </Card.Text>
           
            </Card.Body>
            </Card>
                
            <br />
    
            </Col>
            <Col lg={6} sm={12}>
            <iframe title="google_maps" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3717.2894314168516!2d-157.85669878418108!3d21.299576883851767!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x7c006de2375ef0c9%3A0x5b36d34d62a37c31!2s875%20Waimanu%20St%2C%20Honolulu%2C%20HI%2096813!5e0!3m2!1sen!2sus!4v1602130250217!5m2!1sen!2sus"
                    style={{
                    width: '100%', minWidth:'100%', maxWidth:'100%', minHeight:'40vh', frameborder:"0", allowfullscreen:"", ariaHidden:"false", tabindex:"0"
                    }}></iframe>
            </Col>
        </Row>
        <br />
        <p className='mainFont' style={{fontSize: '1.5em'}}>Upcoming Events</p><hr/>
        <Row style={{marginTop: '25px'}}>
        
            <Col lg={6} sm={12}>
       
            <Image style ={{width: '100%'}}src={about4Image} rounded/>
            </Col>
            <Col lg={6} sm={12}>
              <EventsPage/>
            </Col>
      
        </Row>
        </Container>
        <br />
        <br />
        <br />
        </>
    )
}
